import { GLOBALS } from "../../js/globals";

setTimeout(() => {
    GLOBALS.H.classList.add('_is-preloaded');
}, 500);
